import api from "./axios";

export const fetchInvoices = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.page) params.append("page", filters.page);
  if (filters.per_page) params.append("per_page", filters.per_page);
  if (filters.customer_id) params.append("customer_id", filters.customer_id);
  if (filters.status) params.append("status", filters.status);
  if (filters.from_date) params.append("from_date", filters.from_date);
  if (filters.to_date) params.append("to_date", filters.to_date);
  if (filters.search) params.append("search", filters.search);
  return api.get(`/invoices?${params.toString()}`);
};

export const fetchInvoiceCounts = (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.customer_id) params.append("customer_id", filters.customer_id);
  if (filters.from_date) params.append("from_date", filters.from_date);
  if (filters.to_date) params.append("to_date", filters.to_date);
  if (filters.search) params.append("search", filters.search);
  return api.get(`/invoices/counts?${params.toString()}`);
};

export const fetchInvoiceById = (id) => {
  return api.get(`/invoices/${id}`);
};

export const createInvoice = (data) => {
  return api.post("/invoices", data);
};

export const updateInvoice = (id, data) => {
  return api.put(`/invoices/${id}`, data);
};

export const deleteInvoice = (id) => {
  return api.delete(`/invoices/${id}`);
};

export const cancelInvoice = (id) => {
  return api.post(`/invoices/${id}/cancel`);
};

export const addRepayment = (invoiceId, data) => {
  return api.post(`/invoices/${invoiceId}/repayments`, data);
};

export const deleteRepayment = (invoiceId, repaymentId) => {
  return api.delete(`/invoices/${invoiceId}/repayments/${repaymentId}`);
};

export const openInvoicePdf = async (invoiceId) => {
  const blob = await api.get(`/invoices/${invoiceId}/pdf`, {
    responseType: "blob",
  });

  if (blob instanceof Blob && blob.type && !blob.type.includes("pdf")) {
    const text = await blob.text();
    let errorMsg = "Server returned an error instead of PDF";
    try {
      const json = JSON.parse(text);
      errorMsg = json.message || errorMsg;
    } catch {
      // not JSON
    }
    throw new Error(errorMsg);
  }

  const pdfBlob = new Blob([blob], { type: "application/pdf" });
  const url = window.URL.createObjectURL(pdfBlob);
  window.open(url, "_blank");
};
